import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function() {

  (function thinkGreen() {

    const modules = document.querySelectorAll(".block__hkbis-think-green");

    if (modules && modules.length > 0) {

      [...modules].forEach(module => {

        const circles = module.querySelectorAll(".block__hkbis-think-green__text-container__overflow-container__circle-container--circle");

        if (circles) {

          [...circles].forEach((circle) => {

            let timeline = gsap.timeline({
              scrollTrigger: {
                trigger: module,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
              },
            });

            timeline.to(circle, {
              rotate: 360,
              ease: "none",
            });
          });
        }
      })
    }
  })();
});
